export const STORAGE_KEY = 'mimir.navigationStack';

/**
 * Persists the in-app navigation stack for the lifetime of one browser tab.
 *
 * sessionStorage is per-tab and survives a reload, so back keeps naming the
 * page it will return to instead of falling back to the section parent. A new
 * tab starts empty, which is what keeps the deep-link fallback intact.
 */
class NavigationStackStore {
    constructor(storage) {
        this.storage = storage;
    }

    load(current) {
        let stack;
        try {
            stack = JSON.parse(this.storage?.getItem(STORAGE_KEY));
        } catch (error) {
            return [];
        }
        if (!Array.isArray(stack) || stack.length === 0) return [];

        // Only trust a stack whose top is where the browser actually is: anything
        // else means the tab moved on without us and the trail is not ours.
        const top = stack[stack.length - 1];
        if (top?.pathname !== current.pathname || top?.idx !== current.idx) return [];

        // A reload can re-key the entry the browser restored, so adopt the live
        // key or the reducer would treat this page as a new one and duplicate it.
        return [...stack.slice(0, -1), { ...top, key: current.key }];
    }

    save(stack) {
        try {
            this.storage?.setItem(STORAGE_KEY, JSON.stringify(stack));
            return true;
        } catch (error) {
            return false;
        }
    }
}

export default NavigationStackStore;
